<div class="flex flex-col rounded shadow bg-slate-100">
    <div class="flex flex-row p-2 gap-2 items-center text-sm shadow">
        @if (result.isPending) {
            <div class="p-1 text-white rounded shadow-sm w-[8ch] text-center" [style.background]="ColorPending">Pending</div>
        } @else {
            @if (result.isSuccess) {
                <div class="p-1 text-white rounded shadow-sm w-[8ch] text-center" [style.background]="ColorSuccess">Success</div>
            } @else {
                <div class="p-1 text-white rounded shadow-sm w-[8ch] text-center" [style.background]="ColorFailed">Failed</div>
            }
        }
        <div class="grow" title="{{ result.startedAt }}">{{ result.startedAt | datetime:true }}</div>
        <button (click)="onShowDetailsClicked()" class="hover:text-ponder-linkhover">
            @if (!showDetails) {
                See Details
            } @else {
                Hide Details
            }
        </button>
    </div>
    @if (showDetails) {
        <div class="bg-slate-50 p-2 rounded-b flex flex-col gap-2 text-sm">
            @if (result.result?.collectionImports?.length) {
                @for (collection of result.result!.collectionImports! ; track collection.game) {
                    <div class="flex flex-row gap-4">
                        <div>
                            <span class="font-bold">Game:</span> {{ collection.game }}
                        </div>
                        <div>
                            <span class="font-bold">Format:</span> {{ result!.result!.collectionType }}
                        </div>
                        <div>
                            <span class="font-bold">Success:</span> {{ collection.successCount }}
                        </div>
                        <div>
                            <span class="font-bold">Failures:</span> {{ collection.failureCount }}
                        </div>
                        <div>
                            <span class="font-bold">Skipped:</span> {{ collection.skipCount ?? 0 }}
                        </div>
                    </div>
                    @if (collection.failureCount) {
                        <div class="flex flex-row gap-2">
                            <div class="font-bold pt-2">
                                Failure Details
                            </div>
                            <div class="flex flex-col gap-1 bg-white rounded-sm p-2 grow shadow-sm">
                                @for (failure of collection.failures! ; track failure) {
                                    <div>{{ failure }}</div>
                                }
                            </div>
                        </div>
                        <!-- todo finish this -->
                    }
                }
            }
            @if (result.result?.error) {
                <div class="text-red-600">
                    Error: {{ result.result!.error! }}
                </div>
            }
        </div>
    }
</div>